<template>
  <div class="shop-container">
    <!-- <div class="topic-item" v-for="item in imageList" :key='item.id'>
           <img  v-lazy="item.img">
        </div> -->
    <div class="v-timeline theme--light">
      <div class="v-timeline-item theme--light">
        <div class="v-timeline-item__body">
          <div class="v-card">
            <div class="v-card__title headline">派送中</div>
            <div class="v-card__text">
              您的快件正在配送中【齐志强】18273647338
              <div class="c999">05-20 19:20</div>
            </div>
          </div>
        </div>
        <div class="v-timeline-item__divider">
          <div class="v-timeline-item__dot">
            <div class="v-timeline-item__inner-dot primary">
              <van-icon name="cross" size="10px" color="#fff"/>
            </div>
          </div>
        </div>
        <!-- <div class="v-timeline-item__opposite"><span>Tus eu perfecto</span></div> -->
      </div>
      <div class="v-timeline-item theme--light">
        <div class="v-timeline-item__body">
          <div class="elevation-2 v-card v-sheet theme--light">
            <div class="v-card__title headline">派送中</div>
            <div class="v-card__text">
              您的快件正在配送中【齐志强】18273647338
              <div class="c999">05-20 19:20</div>
            </div>
          </div>
        </div>
        <div class="v-timeline-item__divider">
          <div class="v-timeline-item__dot">
            <div class="v-timeline-item__inner-dot primary">
              <van-icon name="cross" size="10px" color="#fff"/>
            </div>
          </div>
        </div>
        <!-- <div class="v-timeline-item__opposite"><span>Tus eu perfecto</span></div> -->
      </div>
      <div class="v-timeline-item theme--light">
        <div class="v-timeline-item__body">
          <div class="elevation-2 v-card v-sheet theme--light">
            <div class="v-card__title headline">已出库</div>
            <div class="v-card__text">
              您的快件正在配送中【齐志强】18273647338
              <div class="c999">05-20 19:20</div>
            </div>
          </div>
        </div>
        <div class="v-timeline-item__divider">
          <div class="v-timeline-item__dot">
            <div class="v-timeline-item__inner-dot primary">
              <van-icon name="cross" size="10px" color="#fff"/>
            </div>
          </div>
        </div>
        <!-- <div class="v-timeline-item__opposite"><span>Tus eu perfecto</span></div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shopTopicList',
  data () {
    return {
      imageList: [
        {
          id: 111,
          topicCover: 'https://img.yzcdn.cn/vant/apple-1.jpg'
        },
        {
          id: 222,
          topicCover: 'https://img.yzcdn.cn/vant/apple-1.jpg'
        }]
    }
  },
  methods: {
    /**
       * @method 专题详情
       * @params {Number} 专题id
       */
    toTopicDetail (id) {
      this.$router.push({ path: 'topic', params: { id: id } })
    }
  }
}
</script>

<style lang="less" scoped>
.shop-container{
  padding: 26px;

  background: #fff;
}
.v-timeline{
  position: relative;
  background: #fff;
  box-sizing: border-box;
  &:before {
    bottom: 0;
    content: "";
    height: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: calc(28px - 1px);
    right: initial;
    width: 1px;
    background: linear-gradient( #e31313, transparent);
  }
  &-item{
    display: flex;
    padding-bottom: 24px;
    flex-direction: row-reverse;
    &__body{
      position: relative;
      max-width: calc(100% - 56px);
      height: 100%;
      flex: 1 1 auto;
      .v-card{
        position: relative;
        padding: 12px;
        // max-width: 100%;
        background-color: #F7f7f7;
        box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) ;
        border-radius: 4px;
        font-size: 24px;
        color: rgba(0, 0, 0, 0.87);
        line-height: 1.5;
        letter-spacing:2px;
        overflow-wrap: break-word;
        white-space: normal;
        transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
        transition-property: box-shadow, opacity;
        will-change: box-shadow;
      }
    }
    &__divider{
      position: relative;
      min-width: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &__dot{
      background: #FFFFFF;
      align-self: center;
      z-index: 2;
      border-radius: 50%;
      box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
      height: 38px;
      left: calc(50% - 19px);
      width: 38px;
    }
    &:first-child{
      .v-timeline-item__divider>.v-timeline-item__dot{
        align-self: flex-start;
      }
    }
    &:last-child{
      padding-bottom: 0;
      .v-timeline-item__divider>.v-timeline-item__dot{
        align-self: flex-end;
      }
    }
    &__inner-dot{
      display: flex;
      justify-content: center;
      align-items: center;
      height: 30px;
      margin: 4px;
      width: 30px;
      border-radius: 50%;
      background-color: #1867c0;
      border-color: #1867c0;
    }
  }

}
</style>
